import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import { SECTIONS } from 'dpl/auth/components/GenericMobileHeaderDropdownContentV2';
import Icon from 'dpl/common/components/Icon';
import MenuDrawer from 'dpl/search_result_filters/components/SearchResultsHeader/MenuDrawer';

export default function SiteNavLinks({ className }) {
  const menuDrawerRef = useRef(null);
  const [activeSection, setActiveSection] = useState(null);

  function handleSectionClose() {
    setActiveSection(null);
  }

  function closeMenuDrawer() {
    menuDrawerRef.current?.close();
  }

  return (
    <div className={classnames('SiteNavLinks', className)}>
      <ul>
        {SECTIONS.map((section, index) => (
          <li
            key={section.name}
            className={classnames({
              'bt bt-0-ns b--default': index
            })}
          >
            <button
              type="button"
              className="flex items-center justify-between gap-16 md:gap-12 font-16 fw-medium secondary br3 w-100 pv4"
              onClick={() => setActiveSection(section)}
            >
              <span>{section.title}</span>
              <Icon name="fetch-chevron-right" height="24px" width="24px" />
            </button>
          </li>
        ))}
      </ul>
      {activeSection && (
        <MenuDrawer
          ref={menuDrawerRef}
          classes={{ content: 'font-16 pv5 ph4' }}
          onClose={handleSectionClose}
          position="right"
          maxWidth="100%"
          hideHeader
        >
          <button
            className="flex items-center gap-8 tertiary fw-medium pv3 nl2"
            onClick={closeMenuDrawer}
            type="button"
          >
            <Icon name="fetch-chevron-left" height="24px" width="24px" />
            <span>{activeSection.title}</span>
          </button>
          <nav aria-label="Site navigation links">
            <ul>
              {activeSection.links.map((link, index) => (
                <li key={index}>
                  <a
                    className={classnames(
                      'flex items-center fw-medium secondary pv5',
                      { 'bt bt-0-ns b--default': index }
                    )}
                    href={link.href}
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </MenuDrawer>
      )}
    </div>
  );
}

SiteNavLinks.propTypes = {
  className: PropTypes.string
};

SiteNavLinks.defaultProps = {
  className: null
};
